import {FILTER_DEFAULT} from "../constants/CommonConstants";
import {VIEW_TO_STATIC_FILTERS_MAP} from "../dataStore/FilterDataStore";
import {isFilterConfigured} from "../../util/CommonUtils";

export const FiltersStateReducer = (state, action) => {
        switch (action.type) {
            case 'TOGGLE_VIEW_OPTIONS':
            {
                state.isApplyFilterClicked = false;
                return {...state, isOptionsVisible : !action.isOptionsVisible}
            }    
            case 'SELECT_FILTER':
            {
                state.isApplyFilterClicked = false;
                return {...state, [action.key] : action.value}
            }
            case 'REMOVE_FILTER_ARRAY':
            {
                state.isApplyFilterClicked = false;
                return {...state, [action.key] : state[action.key].filter(value => value !== action.value)}
            }  
            case 'REMOVE_FILTER':
            {
                state.isApplyFilterClicked = false;
                return { ...state, [action.key] : ""}
            }
            case 'REMOVE_ALL_FILTERS':
            {
                Object.keys(state)
                    .filter((key) => key in FILTER_DEFAULT && !VIEW_TO_STATIC_FILTERS_MAP[action.view].includes(key))
                    .filter((key) => isFilterConfigured(key, action.context))
                    .forEach( (key) => { state[key] = FILTER_DEFAULT[key]})
                state.isApplyFilterClicked = false;
                return { ...state}
            }
            case 'APPLY_FILTER':
                { 
                    state.isApplyFilterClicked = true;
                    return { ...state}    
                }                           
            default:
                return state
        }
        
 }



// WEBPACK FOOTER //
// ./src/commons/reducer/FiltersStateReducer.js